import { css } from '@emotion/react';
import type { ReportDemographicData } from '~/exportReport/exportReportData.helpers';
import type { ReportTemplate } from '~/exportReport/template/reportTemplate';
import { ExportReportTemplateRendererComponent } from '~/exportReport/templateRenderer/exportReportTemplateRenderer.component';
import { useExportReportParams } from '~/exportReport/useExportReportParams';
import type { ExportReportPolygonParams } from '~/store/mapSettings/toolsState/exportReport/exportReportToolState.state';

const wrapperStyle = css({
  padding: 20,
  maxWidth: 1000,
  margin: '0 auto',
});

type MapExportReportPreviewPolygonProps = Readonly<{
  params: ExportReportPolygonParams;
  template: ReportTemplate;
  getDemographicLabel: (demographicId: string) => string | null;
  getDemographicData: (columnId: string, demographicId: string) => ReportDemographicData | null;
  isLoading: boolean;
}>;

export const MapExportReportPreviewPolygonComponent = ({
  template, params, getDemographicData, getDemographicLabel, isLoading,
}: MapExportReportPreviewPolygonProps) => {
  const { tableColumns } = useExportReportParams();

  return (
    <div css={wrapperStyle}>
      <ExportReportTemplateRendererComponent
        template={template}
        tableColumns={tableColumns}
        summaryProps={{
          heading: params.data.heading,
        }}
        mapProps={{
          type: params.type,
          paths: params.data.paths,
        }}
        getDemographicLabel={getDemographicLabel}
        getDemographicData={getDemographicData}
        isLoading={isLoading}
      />
    </div>
  );
};
